/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import {StyleSheet} from 'aphrodite';

const styles = StyleSheet.create({
	progressBar: {
		marginBottom: '1.25rem'
	}
});

export default styles;
